import { jsx as e } from "react/jsx-runtime";
import s from "./roche-published-date.module.scss.js";
const r = ({ publishedDate: i }) => /* @__PURE__ */ e("div", { className: s["published-date"], children: /* @__PURE__ */ e("time", { children: i }) });
export {
  r as RocheUIPublishedDate
};
